// extracted by mini-css-extract-plugin
module.exports = {"container":"SingleFieldLookupAddressForm_container__DBsZg","postcodeInput":"SingleFieldLookupAddressForm_postcodeInput__N__Qp"};